import {
  WFComponent,
  WFDynamicList,
  WFFormComponent,
} from "@xatom/core";
import { publicQL } from "../../graphql";
import {
  PaymentPlan,
  PublicListPlansDocument,
} from "../../graphql/graphql";
import stateArray from "../utils/statesArray";
import { PORTAL_URL } from "../../config";

const pricingLanding = () => {
  const req = publicQL.query(PublicListPlansDocument);
  const stateField = new WFComponent<HTMLInputElement>(
    "#state"
  );
  stateField.getElement().replaceChildren();
  const statesArray = [{
    name: "Select a state to see the plans",
    value: ""
  }, ...stateArray];
  statesArray.forEach((state) => {
    const option = document.createElement("option");
    option.value = state.value;
    option.textContent = state.name;
    stateField.getElement().appendChild(option);
  });
  const pricingContainer = new WFComponent(`.pricing_tab`);
  pricingContainer.setAttribute("style", "opacity:0;");
  const pricingForm = new WFFormComponent(`#price-form`);
  const stateSelectDD = pricingForm.getChildAsComponent(`[xa-type="state-select-dd"]`);
  const planSubmitButton = pricingForm.getChildAsComponent(`[xa-type="plan-submit-button"]`);
  planSubmitButton.getElement().setAttribute("disabled", "disabled");
  planSubmitButton.setAttribute("style", "background-color: #B7B7B7");
  const priceList = new WFDynamicList<
    string,
    HTMLDivElement,
    HTMLDivElement,
    HTMLDivElement
  >(pricingForm.getChildAsComponent(`.pricing_tab-menu`), {
    rowSelector: `.tab_button`,
  });
  let selectedIndex = 0;
  let plans: PaymentPlan[] = [];
  const renderPrice = () => {
    const plan = plans[selectedIndex] || plans[0];
    if (plan)
      pricingForm.updateTextVariable({
        p: `${plan.amount}`,
        year: plan.durationText,
        rates: plan.description.split(" - ")[1] || "-",
      });
    else {
      pricingForm.updateTextVariable({
        p: `0`,
        year: "year",
        rates: "Not Available",
      });
    }
  };
  const renderPlans = () => {
    const val = stateField.getElement().value;
    plans = req
      .data()
      .publicListPlans.filter((d) =>
        d.applicableStates.includes(val)
      ).sort((p1,p2) => p1.listOrder - p2.listOrder);
    selectedIndex = 0;
    priceList.setData(
      plans.map((d) => d.description.split(" - ")[0])
    );
    console.log(plans);
    renderPrice();
  };
  stateField.on("change", (d) => {
    const stateDropdown = stateSelectDD.getElement();
    const value = stateDropdown.options[stateDropdown.selectedIndex].value;
    if (value) {
      planSubmitButton.getElement().removeAttribute("disabled");
      planSubmitButton.removeAttribute("style");
    } else {
      planSubmitButton.getElement().setAttribute("disabled", "disabled");
      planSubmitButton.setAttribute("style", "background-color: #B7B7B7");
    }
    renderPlans();
  });
  priceList.rowRenderer(
    ({ rowData, rowElement, index }) => {
      rowElement.removeCssClass("active");
      rowElement.on("click", () => {
        selectedIndex = index;
        priceList.forceRender();
        renderPrice();
      });
      if (selectedIndex === index) {
        rowElement.addCssClass("active");
      }
      rowElement.updateTextVariable({
        planName: rowData,
      });
      return rowElement;
    }
  );
  pricingForm.onFormSubmit((data) => {
    const plan = plans[selectedIndex] || plans[0];
    if (plan) {
      window.open(
        `${PORTAL_URL}?state=${
          stateField.getElement().value
        }&planId=${plan.id}`,
        "_blank"
      );
    } else {
      alert("Please select valid plan");
    }
  });
  req.onData((data) => {
    renderPlans();
    pricingContainer.setAttribute("style", "opacity:1;");
  });
  req.fetch();
};

export default pricingLanding;
